<app-navbarlanding></app-navbarlanding>

<router-outlet></router-outlet>


<footer class="py-5">
    <div class="container">
        <div class="row align-items-center justify-content-xl-between">
            <div class="col-xl-6">
                <div class="copyright text-center text-xl-left text-muted">
                    &copy; {{ test | date: "yyyy" }} <a href="" class="font-weight-bold ml-1" target="_blank">Más Seguros Colombia Ltda.</a>
                </div>
            </div>
            <div class="col-xl-6">
                <ul class="nav nav-footer justify-content-center justify-content-xl-end">
                    <li class="nav-item">
                        <a href="" class="nav-link" target="_blank">Más Seguros Colombia Ltda.</a>
                    </li>
                    <li class="nav-item">
                        <a href="" class="nav-link" target="_blank">Acerca de Nosotros</a>
                    </li>

                </ul>
            </div>
        </div>
    </div>
</footer>